// extracted by mini-css-extract-plugin
export default {"content":"p_86j","code":"f98Oz"};